import React, { useState } from "react";
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter, Card, CardBody, FormFeedback, Label, Input } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
//Import Breadcrumb

import Select from "react-select";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import { withRouter, useHistory } from "react-router-dom";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { CopyToClipboard } from "react-copy-to-clipboard";


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}


const CollaboratorDetails = props => {
  //meta title
  document.title = "Collaborator Details";
  const history = useHistory();
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};

    const [UsersTBody, setUsersTBody] = React.useState('');
    const handleT1Body = async (tempData) => {
      let tempTBody = tempData.map((element, index) => (
        <tr key={index}>
          <td>{element.u_id}</td>
          <td>{element.first_name}</td>
          <td>{element.last_name}</td>
          <td>{element.email}</td>
          <td>{element.country}</td>
          <td>+{element.country_code} {element.phone.slice(0, 6)}****&nbsp;
              {parseInt(element.is_phone_verified) === 1 ? (
                <CheckCircleIcon style={{ color: 'green' }} />
              ) : (
                <CancelIcon style={{ color: 'red' }} />
              )}
          </td>
          <td className="text-center">
            <div className="centerLink">
            <Link title="Transactions" to={"/transaction/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-list-ul"></i></Link>
            </div>
          </td>
        </tr>
      ));
  
      setUsersTBody(tempTBody);
    }

    const handleReferralLinkCopied = () => {
        setAlertData({
          variant: 'success',
          message: "Link copied!",
        });
        resetAlertData();
    };
    const [ ReferralLink, setReferralLink ] = React.useState('');
    const [ collaboratorsUsersCount, setCollaboratorsUsersCount ] = React.useState('');

    const handleLoadGetUsers = async () => {
      const res = await getRequest('get-users');
      if (res && res.code === 200) {
        let originalText = res.data;
        let collaboratorsUsersData = [];
        originalText.forEach(element => {
          if(element.parent_collaborator_u_id==atob(props.match.params.id)){
            collaboratorsUsersData.push(element);
          }
          if(element.u_id==atob(props.match.params.id)){
            setReferralLink(process.env.REACT_APP_SITE_URL+'register/collaborator/'+element.collaborator_referral_code);
        }
        });
        setCollaboratorsUsersCount(collaboratorsUsersData.length)
        handleT1Body(collaboratorsUsersData);
      }
      else {
        let tempTBody = (<tr>
                          <td colSpan="9" className="text-center">No records found</td>
                        </tr>);
  
        setUsersTBody(tempTBody);
  
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: res.message,
        }));
      }
      resetAlertData();
    }
  
    const [AllCountriesData, setAllCountriesData] = React.useState([]);
    const handleLoadGetAllCountries = async () => {
      const res = await getRequest('get-all-countries');
      if (res && res.code === 200) {
        let originalText = res.data;
  
        let tempArr = [{label: 'All', value: 'All'}];
        originalText.forEach(element => {
          let temp = {
              label: element.country_name,
              value: element.country_name,
          };
          tempArr.push(temp);
        });
        tempArr = [{
            options: tempArr
        }];
        setAllCountriesData(tempArr);
      }
      else {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: res.message,
        }));
      }
      resetAlertData();
    }


  React.useEffect(() => {
    if (!props.match.params.id) {
      history.push({
        pathname: '/collaborators',
        state: { code: 401, status: 'error', message: 'ID not found! Please provide a valid ID.' }
      });
	}
    else {
        handleLoadGetUsers();
        handleLoadGetAllCountries();
    }
  }, []);


  return (
    <React.Fragment>
            {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Tokenizedgreen" breadcrumbItem="Collaborators Details" />

         

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                <Col xs="12">
                    <Row>
                      <Col xl="12" md="12">
                        <div className="card">
                          <div className="card-body">
                            <div className="mb-3 h4 card-title">Collaborator Referral Link</div>
                            <div className="Referal">
                              <p>{ReferralLink}</p>
                              <CopyToClipboard text={ReferralLink} onCopy={handleReferralLinkCopied}>
                                <i className="bx bx-copy-alt"></i>
                              </CopyToClipboard>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </CardBody>
            </Card>
            </Col>
            </Row>

            <Row>
            <Col lg="12">
                <Col lg="3" md="6">
                    <Card>
                    <CardBody className="pb-3">
                        <Link to="#" className="d-flex flex-wrap">
                        <div>
                            <h5 className="card-title mb-3 me-2">Users</h5>
                            <h4 className="mb-0">{collaboratorsUsersCount}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                            <i className="bx bx-user display-4 text-light"></i>
                        </div>
                        </Link>
                    </CardBody>
                    </Card>
                </Col>
            </Col>
            </Row>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                 


                <div className="mb-3 h4 card-title">Users List</div>

                  <div className="table-rep-plugin">
                    <div className="table-responsive mb-0">
                      <table className="table table-hover table-highlight" style={{ minWidth: '1500px' }}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email ID</th>
                            <th>Country Name</th>
                            <th>Mobile No.</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {UsersTBody}
                        </tbody>
                      </table>
                    </div>
                    <div className="infoIcon">

                    <div className="infoIconBox">
                    <i className="bx bx-list-ul"></i>
                    <p>Transactions</p>
                    </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>

    </React.Fragment>
  );
};

export default withRouter(CollaboratorDetails);
